import { useCallback, useContext } from "react";
import { CONTENT_BASE_URL } from "../../../shared/constants";
import { ModuleContext } from "../../../shared/providers/module/module.provider";
import { IImageProps } from "./Image.interface";
import { TranslationContext } from "../../../shared/providers/translation/translation.provider";
import { ComponentTypes, ItemTypes } from "../../../shared/interfaces/modules.interface";
import { useIntersectionObserver } from "../../../shared/hooks/useIntersectionObserver";

function Image({ image, unitId, id }: IImageProps) {
    const { url, alt = "", width, height } = image;
    const { setProgress } = useContext(ModuleContext);
    const { lang } = useContext(TranslationContext);

    const handleProgress = useCallback(() => {
        if (lang && unitId) {
            setProgress({
                unitId: unitId,
                itemId: id,
                progress: 100,
                itemType: ComponentTypes.IMAGE,
                itemLocale: lang
            });
        }
    }, [lang, unitId]);

    const checkProgress = useCallback((entry: any) => {
        if (entry.isIntersecting) handleProgress();
    }, []);

    const { ref } = useIntersectionObserver(checkProgress);

    return (
        <section className="unit_item container-fluid gx-2">
            <div className="row gx-0">
                <div className="col-12">
                    <img
                        className="w-100 h-auto"
                        ref={ref}
                        src={`${CONTENT_BASE_URL}${url}`}
                        alt={alt}
                        width={width}
                        height={height}
                    />
                </div>
            </div>
        </section>
    );
}

export default Image;
